module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-hd-fill-97f773c9.svg";